module.exports = __webpack_public_path__ + "media/dog-weight/great-dane-white-d313bf1d.svg";